// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper {\n    border: 1px solid #42c0d9;\n    borderRadius: 2px;\n    transform: translate(-50%, -50%);\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    width: 600px;\n    padding: 3rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}", ""]);
// Exports
module.exports = exports;
